import * as React from 'react';
import Grid from '@mui/material/Grid';
import { DataGrid } from '@mui/x-data-grid';
import Box from '@mui/material/Box';
import { useAuthenticator } from '@aws-amplify/ui-react';
import { Icon } from '@aws-amplify/ui-react';
import { View, useTheme } from "@aws-amplify/ui-react";
import { MdArrowForwardIos } from 'react-icons/md';
import './Profile.css'

export const CustomIconWithLibExample = () => {
  return <Icon as={MdArrowForwardIos} />;
};
export default function ProfileGrid() {

  const { user } = useAuthenticator((context) => [context.user]);

  const pwstyle = {
    color: "black",
    'margin-right': "1px"
  };

  const columns = [
    {
      field: "name",
      width: 300,
      renderCell: (params) => (
        <div>
          <h3>{params.value.title}</h3>
          <p>
            <span style={pwstyle}>•</span>
            <span style={pwstyle}>•</span>
            <span style={pwstyle}>•</span>
            <span style={pwstyle}>•</span>
            <span style={pwstyle}>•</span>
            <span style={pwstyle}>•</span>
            <span style={pwstyle}>•</span>
            <span style={pwstyle}>•</span>
            <span style={pwstyle}>•</span>
            <span style={pwstyle}>•</span>
          </p>
        </div>
      )
    },
    // {
    //   field: "go",
    //   width: 50,
    //   renderCell: () => (
    //     <div>
    //       <MdArrowForwardIos />
    //     </div>
    //   )
    // }
  ];

  const rows = [
    {
      id: 1,
      name: { name: user.attributes["custom:password"], title: "Password" },
      go: ''
    }
  ];


  return (
      <Box sx={{ height: '100%', width: '350' }}>
        <DataGrid
          getRowHeight={() => 'auto'}
          slots={{
            columnHeaders: () => null,
          }}
          rows={rows}
          columns={columns}
          hideFooter={true}
          sx={{
            boxShadow: 0,
            border: 0,
            m: 0,
            borderColor: 'white',
            '& .MuiDataGrid-cell:hover': {
              color: 'inherit',
            },
          }}
        />
      </Box>
    );
  }

export function Security() {

  const { tokens } = useTheme();
  

  return (
    <>
    <Grid
      templateColumns="1fr 1fr"
      templateRows="6rem 6rem 6rem"
      gap={tokens.space.small}
      marginLeft={{ large: "5em" }}
      marginRight={{ large: "5em" }}
      marginTop={{ base: "1em", small: "1em", medium: "1em", large: "1em" }}
      marginBottom={{ base: "3em", small: "3em", medium: "3em", large: "3em" }}
    >
      <View
        columnSpan={[2, 2, 2, 2]}
        backgroundColor={tokens.colors.grey}
        marginTop={{ base: "1em", small: "1em", medium: "2em", large: "1em" }}
        marginLeft={{ base: "1em", small: "1em", medium: "3em", large: "3em" }}
        marginRight={{ base: "1em", small: "1em", medium: "3em", large: "3em" }}
      >
        <h2>Accesso a Merum</h2>
          <ProfileGrid />
      </View>
      
    </Grid>
    </>
    
  );
}